import { makeStyles } from "@material-ui/core/styles";

// Folha presa ao rodapé e centralizada pelo container do Dialog (não por
// `position: fixed; left: 50%`). Ao abrir, o MUI esconde a scrollbar e soma a
// largura dela ao padding-right do body; o Dialog com a classe global
// `mui-fixed` recebe o mesmo padding e fica alinhado à coluna da página.
// Uso: <Dialog className={BOTTOM_SHEET_FIXED_CLASS} classes={{ container: classes.container }} />
export const BOTTOM_SHEET_FIXED_CLASS = "mui-fixed";

const useBottomSheetClasses = makeStyles({
	container: {
		alignItems: "flex-end",
	},
});

export default useBottomSheetClasses;
